import styled from 'styled-components'
import { SPACING, BORDER_RADIUS, TYPOGRAPHY, FONT_WEIGHT, COLORS } from '../../../styles/theme'

/**
 * A sophisticated, left-aligned card used as the "this tab has no content yet"
 * empty state on the Synthesis tab. Composes with primary/secondary CTAs.
 */
export const Callout = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${SPACING.lg};
  padding: ${SPACING.xxl} ${SPACING.xxl} ${SPACING.xl};
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: ${BORDER_RADIUS.xl};
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0 auto 0 0;
    width: 3px;
    background: linear-gradient(180deg, ${COLORS.primary} 0%, ${COLORS.purple500} 100%);
  }
`

export const CalloutHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.md};
`

export const CalloutIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${BORDER_RADIUS.md};
  background: linear-gradient(135deg, ${COLORS.primary} 0%, ${COLORS.purple500} 100%);
  color: #fff;
  flex-shrink: 0;
`

export const CalloutTitle = styled.h3`
  font-size: ${TYPOGRAPHY.h4.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
  margin: 0;
  line-height: 1.3;
`

export const CalloutBody = styled.p`
  font-size: ${TYPOGRAPHY.body.fontSize};
  color: var(--color-text-secondary);
  line-height: 1.6;
  margin: 0;
  max-width: 580px;
`

export const CalloutActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACING.sm};
  align-items: center;
`

export const CalloutFootnote = styled.div`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-secondary);
  padding-top: ${SPACING.md};
  border-top: 1px solid var(--color-border);
`
